<template>
  <div>
  <div class="footBox">
    <div>
      <div class="footLogo">
        <img src="../../assets/newImg/logo.png" alt="" style="width: .45rem;height: .42rem">
        <h1 class="titlefoot">汇智衣服装制造全流程服务平台</h1>
      </div>
      <div class="inforBox" style="margin-top: .56rem;">
        <p style="display: flex;">
          <img src="../../assets/img/icon_phone.png" alt="" style="width: .32rem;height: .32rem; vertical-align: middle;">
          <span style="display: inline-block;margin-left: .34rem;font-size: 0.16rem">{{ $t('meg.contactsInformation') }}: 4009901958</span>
        </p>
        <p style="margin-top: .3rem;display: flex;">
          <img src="../../assets/img/address.png" alt="" style="width: .32rem;height: .32rem;vertical-align: middle;">
          <span style="display: inline-block;margin-left: .34rem;font-size: 0.16rem">{{ $t('meg.address') }}: 山东省威海市环翠区环翠楼街道世昌大道26号三楼</span>
        </p>
        <!-- <p style="margin-top: 30px;display: flex; ">
          <img src="../../assets/img/chuanzhen.png" alt="" width="32px" height="32px" style="vertical-align: middle;">
          <span style="display: inline-block;margin-left: 34px;">传真: XXXXX</span>
        </p> -->
        <p style="margin-top: .3rem;display: flex;">
          <img src="../../assets/img/icon_email.png" alt="" style="width: .32rem;height: .32rem;vertical-align: middle;">
          <span style="display: inline-block;margin-left: .34rem;font-size: 0.16rem">{{ $t('meg.email') }}: server@hzymris.com</span>
        </p>
      </div>
    </div>
    <div class="centerFoot" style="margin-top: .83rem">
        <!-- <p>首页</p>
        <p>平台介绍</p>
        <p>新款产品展示(ODM)</p>
        <p>新闻资讯</p>
        <p>平台工厂</p>
        <p>走进汇智衣</p> -->
    </div>
    <div style="margin-top:.83rem;text-align: left;margin-right: 1.75rem;">
      <p class="follow">{{ $t('meg.follow') }}</p>
      <div style="margin-top: .38rem">
        <el-popover placement="left-start" title="关注公众号" width="2.88rem" trigger="hover">
            <img src="../../assets/newImg/erweima.jpg" alt="" style="width: 2.5rem;height: 2.5rem;">
            <template #reference>
              <span style="margin-right: .29rem;cursor: pointer;">
                <img src="../../assets/newImg/icon_weixin.png" alt="" style="width: .4125rem;height: .3375rem;">
              </span>
            </template>
          </el-popover>
      </div>
    </div>
  </div>
  <div style="height: 0.86rem;font-size: .2rem;font-family: Source Han Sans CN, Source Han Sans CN;font-weight: 400;color: #000000;line-height: .86rem;">山东汇智衣工业科技有限公司 <a href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2023040466号-1</a> </div>
</div>
</template>

<script>
</script>

<style scoped>
.footBox {
  width: 100%;
  height: 4.35rem;
  background: #FFFFFF;
  border-radius: 0px 0px 0px 0px;
  opacity: 1;
  border-top: 0.01rem solid #DDDDDD;
  border-bottom: 0.01rem solid #DDDDDD;
  display: flex;
  justify-content: space-evenly;
}

.foot_title {
  margin-top: .68rem;
}

.titlefoot {
  font-size: .24rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 400;
  color: #000000;
  margin-left: .3rem;
  line-height: .4rem;
}

.footLogo {
  display: flex;
  margin-top: .68rem;
}

.inforBox p {
  text-align: left;
}
.centerFoot p {
  font-size: 0.18rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  color: #000000;
  line-height: .24rem;
  text-align: left;
  margin-bottom: .35rem;
}
.follow {
  font-size: .18rem;
  font-family: Source Han Sans CN, Source Han Sans CN;
  font-weight: 500;
  color: #000000;
}
</style>
